/**
 * @generated SignedSource<<bb2648d7c9b6263f067d1f03a2be5659>>
 * @relayHash b09c61ebcd4786306f285a09c00b46d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1598b086c3f195764dc7f43a077d4dccc64e138fb6bc029f238644fb89a6d38c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConnectedToIssueAggQuery$variables = {
  cloudId: string;
  consistentRead?: boolean | null;
  includeAgentSessionsInConnectedTo?: boolean | null;
  includeDesignPanelData: boolean;
  includeIncidentCommandCenterData: boolean;
  includeReleasesPanelDevOpsData: boolean;
  includeWhiteboardsCountInAttachmentConsolidation: boolean;
  isAnonymous: boolean;
  isJsmPreventionCenterEnabled: boolean;
  issueKey: string;
  siteAri: string;
  workItemModernizationEnabled: boolean;
};
export type ConnectedToIssueAggQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly agentSessionsConnectedToFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"IssueViewAgentPanel_connectedTo">;
      } | null;
      readonly contentItemsFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentItemsView_connectedToIssueFragment">;
      };
      readonly headerActionsSectionConnectedToFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"HeaderActionsSection_connectedToFragment">;
      } | null;
      readonly incidentCommandCenterFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"IssueLayoutWithIssueLayoutState_shouldShowIncidentCommandCenter">;
      } | null;
      readonly preventionCenterOverviewTabContentFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"PreventionCenterOverviewTabContent_connectedToIssueFragment">;
      } | null;
      readonly statusPagesIncidentCommandCenterFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ChildrenIssuesSection_shouldShowIncidentCommandCenter">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ConfluenceContentV2Whiteboards" | "IncidentOverviewTabContent_connectedToIssueFragment" | "ResourcesSectionWhiteboardsCount">;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CompactLayoutItemsSection_connectedToQuery" | "DesignSectionDesignPanelWrapper" | "DetailsPanelsSection_connectedToQuery" | "DetailsPanelsSection_connectedToSafeQuery" | "WorkItemLayout_connectedAggData">;
};
export type ConnectedToIssueAggQuery = {
  response: ConnectedToIssueAggQuery$data;
  variables: ConnectedToIssueAggQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx": isJsmIncidentCommandCenterIncidentSummaryEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterSuggestedResourcesRelayProvidertsx": isJsmIncidentCommandCenterSuggestedResourcesEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider": JiraAiAgentTeamSessionsEnabledRelayProvider_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider": JiraAiLocalAgentSessionsEnabledRelayProvider_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiReadAgentSessionsMainTopLevelAgentRelayProvider": JiraAiReadAgentSessionsMainTopLevelAgent_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsTimestampRelayProvider": JiraAiAgentTeamSessionsTimestampRelayProvider_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgentSessionCardExperimentRelayProvider": JiraAgentSessionCardExperimentRelayProvider_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx": removeDesignProviderTypeFilter_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": removeCtiaqConfigState_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgentSessionCardExperimentRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsTimestampRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiReadAgentSessionsMainTopLevelAgentRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterSuggestedResourcesRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx: {
    readonly get: () => boolean;
  };
});

import removeDesignProviderTypeFilter_provider from '@jira/platform__graphql-relay-provider/src/IsRemoveJswddFetchOperationEnabledRelayProvider';
import JiraAgentSessionCardExperimentRelayProvider_provider from '@jira/platform__graphql-relay-provider/src/JiraAgentSessionCardExperimentRelayProvider';
import JiraAiAgentTeamSessionsEnabledRelayProvider_provider from '@jira/platform__graphql-relay-provider/src/JiraAiAgentTeamSessionsEnabledRelayProvider';
import JiraAiAgentTeamSessionsTimestampRelayProvider_provider from '@jira/platform__graphql-relay-provider/src/JiraAiAgentTeamSessionsTimestampRelayProvider';
import JiraAiLocalAgentSessionsEnabledRelayProvider_provider from '@jira/platform__graphql-relay-provider/src/JiraAiLocalAgentSessionsEnabledRelayProvider';
import JiraAiReadAgentSessionsMainTopLevelAgent_provider from '@jira/platform__graphql-relay-provider/src/JiraAiReadAgentSessionsMainTopLevelAgentRelayProvider';
import isJsmIncidentCommandCenterIncidentSummaryEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmIncidentCommandCenterIncidentSummaryRelayProvider';
import isJsmIncidentCommandCenterSuggestedResourcesEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmIncidentCommandCenterSuggestedResourcesRelayProvider';
import removeCtiaqConfigState_provider from '@jira/platform__graphql-relay-provider/src/RemoveCtiaqConfigStateRelayProvider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "consistentRead"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentSessionsInConnectedTo"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDesignPanelData"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeIncidentCommandCenterData"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReleasesPanelDevOpsData"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWhiteboardsCountInAttachmentConsolidation"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJsmPreventionCenterEnabled"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workItemModernizationEnabled"
},
v12 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v13 = [
  (v12/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 900
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v19 = {
  "kind": "ScalarField",
  "name": "name"
},
v20 = {
  "kind": "ScalarField",
  "name": "picture"
},
v21 = {
  "kind": "ScalarField",
  "name": "title"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v24 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v25 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v27 = [
  {
    "kind": "ScalarField",
    "name": "serviceId"
  },
  (v19/*: any*/)
],
v28 = {
  "kind": "ScalarField",
  "name": "descriptionList"
},
v29 = {
  "kind": "ScalarField",
  "name": "ari"
},
v30 = {
  "kind": "ScalarField",
  "name": "description"
},
v31 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v32 = {
  "kind": "ScalarField",
  "name": "lastUpdatedAt"
},
v33 = {
  "kind": "ScalarField",
  "name": "summary"
},
v34 = {
  "kind": "ScalarField",
  "name": "key"
},
v35 = {
  "kind": "ScalarField",
  "name": "status"
},
v36 = {
  "kind": "ScalarField",
  "name": "type"
},
v37 = {
  "kind": "ScalarField",
  "name": "url"
},
v38 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v39 = [
  {
    "kind": "ScalarField",
    "name": "shouldShowIncidentCommandCenter"
  }
],
v40 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v41 = [
  (v16/*: any*/),
  (v18/*: any*/),
  (v14/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
],
v42 = {
  "kind": "ScalarField",
  "name": "state"
},
v43 = {
  "kind": "ScalarField",
  "name": "convoAiAgentId"
},
v44 = {
  "kind": "ScalarField",
  "name": "lastStateChangeAt"
},
v45 = {
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v18/*: any*/),
    (v14/*: any*/)
  ]
},
v46 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v47 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v48 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v49 = {
  "kind": "ScalarField",
  "name": "enabled"
},
v50 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "siteAri"
},
v51 = [
  (v50/*: any*/)
],
v52 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": (v13/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issueByKey",
        "plural": false,
        "selections": [
          {
            "args": (v47/*: any*/),
            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalDeploymentConnection",
            "kind": "LinkedField",
            "name": "deployments",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalDeploymentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "devOpsState",
                            "kind": "ScalarField",
                            "name": "state"
                          },
                          {
                            "alias": "devOpsLastUpdated",
                            "kind": "ScalarField",
                            "name": "lastUpdated"
                          },
                          {
                            "concreteType": "DevOpsEnvironment",
                            "kind": "LinkedField",
                            "name": "environment",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "category"
                              },
                              (v31/*: any*/)
                            ]
                          }
                        ],
                        "type": "DeploymentSummary"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "externalState",
                            "kind": "ScalarField",
                            "name": "state"
                          },
                          {
                            "alias": "externalLastUpdated",
                            "kind": "ScalarField",
                            "name": "lastUpdated"
                          },
                          {
                            "concreteType": "ExternalEnvironment",
                            "kind": "LinkedField",
                            "name": "environment",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/),
                              (v31/*: any*/)
                            ]
                          }
                        ],
                        "type": "ExternalDeployment"
                      },
                      (v22/*: any*/)
                    ]
                  },
                  (v14/*: any*/)
                ]
              }
            ],
            "storageKey": "deployments(first:100)"
          },
          {
            "args": (v47/*: any*/),
            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalFeatureFlagConnection",
            "kind": "LinkedField",
            "name": "featureFlags",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalFeatureFlagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          (v31/*: any*/),
                          (v34/*: any*/),
                          (v48/*: any*/),
                          {
                            "alias": "devOpsSummary",
                            "concreteType": "DevOpsFeatureFlagSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v49/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "rolloutPercentage"
                              },
                              (v37/*: any*/)
                            ]
                          }
                        ],
                        "type": "DevOpsFeatureFlag"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          (v31/*: any*/),
                          (v34/*: any*/),
                          {
                            "alias": "externalSummary",
                            "concreteType": "ExternalFeatureFlagSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "concreteType": "ExternalFeatureFlagStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v49/*: any*/),
                                  {
                                    "concreteType": "ExternalFeatureFlagRollout",
                                    "kind": "LinkedField",
                                    "name": "rollout",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "percentage"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "ExternalProvider",
                            "kind": "LinkedField",
                            "name": "provider",
                            "plural": false,
                            "selections": [
                              (v48/*: any*/)
                            ]
                          }
                        ],
                        "type": "ExternalFeatureFlag"
                      },
                      (v22/*: any*/)
                    ]
                  },
                  (v14/*: any*/)
                ]
              }
            ],
            "storageKey": "featureFlags(first:100)"
          },
          {
            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalRemoteLinkConnection",
            "kind": "LinkedField",
            "name": "remoteLinks",
            "plural": false,
            "selections": [
              (v24/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "DevOps",
    "kind": "LinkedField",
    "name": "devOps",
    "plural": false,
    "selections": [
      {
        "args": (v51/*: any*/),
        "concreteType": "DevOpsProviders",
        "kind": "LinkedField",
        "name": "providers",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevOpsFeatureFlagProvider",
            "kind": "LinkedField",
            "name": "featureFlagProviders",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v19/*: any*/),
              {
                "kind": "ScalarField",
                "name": "createFeatureFlagTemplateUrl"
              },
              {
                "kind": "ScalarField",
                "name": "connectFeatureFlagTemplateUrl"
              }
            ]
          }
        ]
      }
    ]
  }
],
v53 = {
  "kind": "ScalarField",
  "name": "checkAuth"
},
v54 = {
  "kind": "ScalarField",
  "name": "getEntityByUrl"
},
v55 = [
  {
    "concreteType": "DevOpsDesignProvider",
    "kind": "LinkedField",
    "name": "designProviders",
    "plural": true,
    "selections": [
      (v14/*: any*/),
      (v19/*: any*/),
      {
        "concreteType": "DevOpsSupportedActions",
        "kind": "LinkedField",
        "name": "supportedActions",
        "plural": false,
        "selections": [
          (v53/*: any*/),
          (v54/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "handledDomainName"
      },
      {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/)
            ],
            "concreteType": "JiraAppConfigState",
            "kind": "LinkedField",
            "name": "configState",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraConfigStateConnection",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraConfigState",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v35/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "workspaceId"
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ConnectedToIssueAggQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v13/*: any*/),
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issueByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ConfluenceContentV2Whiteboards"
                },
                {
                  "condition": "includeWhiteboardsCountInAttachmentConsolidation",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ResourcesSectionWhiteboardsCount"
                    }
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "IncidentOverviewTabContent_connectedToIssueFragment"
                },
                {
                  "condition": "isJsmPreventionCenterEnabled",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "PreventionCenterOverviewTabContent_connectedToIssueFragment"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      "kind": "AliasedInlineFragmentSpread",
                      "name": "preventionCenterOverviewTabContentFragment"
                    }
                  ]
                },
                {
                  "condition": "includeIncidentCommandCenterData",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "IssueLayoutWithIssueLayoutState_shouldShowIncidentCommandCenter"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      "kind": "AliasedInlineFragmentSpread",
                      "name": "incidentCommandCenterFragment"
                    },
                    {
                      "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "ChildrenIssuesSection_shouldShowIncidentCommandCenter"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      "kind": "AliasedInlineFragmentSpread",
                      "name": "statusPagesIncidentCommandCenterFragment"
                    },
                    {
                      "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "HeaderActionsSection_connectedToFragment"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      "kind": "AliasedInlineFragmentSpread",
                      "name": "headerActionsSectionConnectedToFragment"
                    }
                  ]
                },
                {
                  "condition": "includeAgentSessionsInConnectedTo",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "IssueViewAgentPanel_connectedTo"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      "kind": "AliasedInlineFragmentSpread",
                      "name": "agentSessionsConnectedToFragment"
                    }
                  ]
                },
                {
                  "fragment": {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ContentItemsView_connectedToIssueFragment"
                      }
                    ],
                    "type": "JiraIssue"
                  },
                  "kind": "AliasedInlineFragmentSpread",
                  "name": "contentItemsFragment"
                }
              ]
            }
          ]
        },
        "action": "THROW"
      },
      {
        "condition": "includeReleasesPanelDevOpsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CompactLayoutItemsSection_connectedToQuery"
          },
          {
            "kind": "FragmentSpread",
            "name": "DetailsPanelsSection_connectedToQuery"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "DetailsPanelsSection_connectedToSafeQuery"
      },
      {
        "condition": "includeDesignPanelData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DesignSectionDesignPanelWrapper"
          }
        ]
      },
      {
        "condition": "workItemModernizationEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "includeAgentSessionsInConnectedTo",
                "variableName": "includeAgentSessionsInConnectedTo"
              },
              {
                "kind": "Variable",
                "name": "includeDesignPanelData",
                "variableName": "includeDesignPanelData"
              }
            ],
            "kind": "FragmentSpread",
            "name": "WorkItemLayout_connectedAggData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterSuggestedResourcesRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiReadAgentSessionsMainTopLevelAgentRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsTimestampRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgentSessionCardExperimentRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx"
      }
    ],
    "kind": "Operation",
    "name": "ConnectedToIssueAggQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "condition": "isAnonymous",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": (v15/*: any*/),
                    "concreteType": "GraphStoreSimplifiedIssueToWhiteboardConnection",
                    "kind": "LinkedField",
                    "name": "whiteboards",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedIssueToWhiteboardEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "concreteType": "ConfluenceWhiteboardLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v17/*: any*/)
                                  },
                                  {
                                    "concreteType": "ConfluenceUserInfo",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v16/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "accountStatus"
                                          },
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v14/*: any*/)
                                        ]
                                      },
                                      (v14/*: any*/)
                                    ]
                                  },
                                  (v21/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "whiteboardId"
                                  }
                                ],
                                "type": "ConfluenceWhiteboard"
                              },
                              (v22/*: any*/)
                            ]
                          },
                          (v23/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": "whiteboards(first:900)"
                  },
                  {
                    "args": (v15/*: any*/),
                    "handle": "connection",
                    "key": "ConfluenceContentV2Whiteboards__whiteboards",
                    "kind": "LinkedHandle",
                    "name": "whiteboards"
                  }
                ]
              },
              {
                "condition": "includeWhiteboardsCountInAttachmentConsolidation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": (v15/*: any*/),
                        "concreteType": "GraphStoreSimplifiedIssueToWhiteboardConnection",
                        "kind": "LinkedField",
                        "name": "whiteboards",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedIssueToWhiteboardEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "createdAt"
                              }
                            ]
                          }
                        ],
                        "storageKey": "whiteboards(first:900)"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "incidentSuggestion",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "generatedAt"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "incidentSummaryDescription"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "probableRCADescription"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "suggestedActions",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedProblemTicketSummary"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedProblemTicketDescription"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedProblemTicketRootCause"
                                  },
                                  {
                                    "concreteType": "AIOpsIncidentAffectedServiceDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedProblemTicketAffectedServices",
                                    "plural": true,
                                    "selections": (v27/*: any*/)
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedProblemTicket"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedIsMajorIncident"
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedMajorIncident"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedUser",
                                    "kind": "LinkedField",
                                    "name": "suggestedAssignees",
                                    "plural": true,
                                    "selections": [
                                      (v16/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedAssignees"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedUser",
                                    "kind": "LinkedField",
                                    "name": "suggestedResponders",
                                    "plural": true,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "avatarUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedResponders"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v30/*: any*/),
                                  (v26/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedPriorityDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedPriority",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                      },
                                      (v19/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedPriority"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedSeverityDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedSeverity",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "severityId"
                                      },
                                      (v19/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedSeverity"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedAutomationRule",
                                    "kind": "LinkedField",
                                    "name": "suggestedAutomationRules",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "ruleId"
                                      },
                                      (v19/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "resourceRuleScopes"
                                      },
                                      {
                                        "concreteType": "AIOpsAutomationRuleUserPrompt",
                                        "kind": "LinkedField",
                                        "name": "userInputPrompts",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "variableName"
                                          },
                                          (v31/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "inputType"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "required"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "defaultValue"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedRcaWithAutomation"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentAffectedServiceDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedAffectedServices",
                                    "plural": true,
                                    "selections": (v27/*: any*/)
                                  },
                                  (v28/*: any*/)
                                ],
                                "type": "AIOpsIncidentSuggestedAffectedServices"
                              }
                            ]
                          }
                        ],
                        "type": "AIOpsIncidentSuggestionResponse"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterSuggestedResourcesRelayProvidertsx",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "incidentSuggestedResources",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v32/*: any*/),
                          {
                            "concreteType": "AIOpsIncidentSuggestedResource",
                            "kind": "LinkedField",
                            "name": "resources",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "resourceId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "link"
                              },
                              (v33/*: any*/)
                            ]
                          }
                        ],
                        "type": "AIOpsIncidentSuggestedResourcesResponse"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isJsmPreventionCenterEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v34/*: any*/),
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v14/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "ChangeManagementJSMPreventionCenterOverviewSummaryResponse",
                    "kind": "LinkedField",
                    "name": "preventionCenterOverviewSummary",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "doneSoFar"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "suggestedNextSteps"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "potentialRisk"
                      },
                      {
                        "concreteType": "ChangeManagementJSMPreventionCenterOverviewSummarySource",
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": true,
                        "selections": [
                          (v29/*: any*/),
                          (v21/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "lastModified"
                          }
                        ]
                      },
                      {
                        "concreteType": "ChangeManagementJSMPreventionCenterOverviewSummaryAnalysisStep",
                        "kind": "LinkedField",
                        "name": "analysisSteps",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v21/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "body"
                          },
                          (v35/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v38/*: any*/)
                ]
              },
              {
                "condition": "includeIncidentCommandCenterData",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v39/*: any*/)
              },
              {
                "condition": "includeAgentSessionsInConnectedTo",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "visibility": "ALL"
                            }
                          }
                        ],
                        "concreteType": "JiraIssueAgentSessions",
                        "kind": "LinkedField",
                        "name": "agentSessions",
                        "plural": false,
                        "selections": [
                          {
                            "args": (v40/*: any*/),
                            "concreteType": "AgentSessionAssociationConnection",
                            "kind": "LinkedField",
                            "name": "connection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AgentSessionAssociationEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "AgentSessionAssociation",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "conversationId"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "startTime"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "triggeredBy",
                                        "plural": false,
                                        "selections": (v41/*: any*/)
                                      },
                                      (v14/*: any*/),
                                      (v16/*: any*/),
                                      {
                                        "concreteType": "AgentSession",
                                        "kind": "LinkedField",
                                        "name": "convoAiSession",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          (v43/*: any*/),
                                          (v14/*: any*/)
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiReadAgentSessionsMainTopLevelAgentRelayProvider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              (v14/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              (v18/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiReadAgentSessionsMainTopLevelAgentRelayProvider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "concreteType": "AgentSession",
                                            "kind": "LinkedField",
                                            "name": "agentSession",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "agent",
                                                "plural": false,
                                                "selections": (v41/*: any*/)
                                              },
                                              (v14/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsTimestampRelayProvider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  (v44/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgentSessionCardExperimentRelayProvider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          (v45/*: any*/),
                                          {
                                            "concreteType": "AgentSession",
                                            "kind": "LinkedField",
                                            "name": "agentSession",
                                            "plural": false,
                                            "selections": [
                                              (v42/*: any*/),
                                              (v44/*: any*/),
                                              (v43/*: any*/),
                                              (v45/*: any*/),
                                              (v14/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "name": "entity",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v34/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                  },
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                          }
                                                        ]
                                                      },
                                                      (v14/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssue"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  (v21/*: any*/),
                                                  (v35/*: any*/),
                                                  {
                                                    "concreteType": "ConfluencePageLinks",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": (v17/*: any*/)
                                                  },
                                                  {
                                                    "concreteType": "ConfluenceContentMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "metadata",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "ConfluenceContentTitleEmoji",
                                                        "kind": "LinkedField",
                                                        "name": "titleEmojiPublished",
                                                        "plural": false,
                                                        "selections": (v46/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "ConfluenceContentTitleEmoji",
                                                        "kind": "LinkedField",
                                                        "name": "titleEmojiDraft",
                                                        "plural": false,
                                                        "selections": (v46/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "ConfluencePage"
                                              },
                                              (v22/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v23/*: any*/)
                                ]
                              },
                              (v25/*: any*/)
                            ],
                            "storageKey": "connection(first:50)"
                          },
                          {
                            "args": (v40/*: any*/),
                            "handle": "connection",
                            "key": "AgentSessionExperience_agentSessions__connection",
                            "kind": "LinkedHandle",
                            "name": "connection"
                          },
                          (v38/*: any*/)
                        ],
                        "storageKey": "agentSessions(filter:{\"visibility\":\"ALL\"})"
                      }
                    ]
                  },
                  (v38/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeReleasesPanelDevOpsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v52/*: any*/)
          }
        ]
      },
      {
        "condition": "includeIncidentCommandCenterData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": (v39/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includeDesignPanelData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v51/*: any*/),
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": (v55/*: any*/)
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "providersWithDesignType",
                    "args": [
                      (v50/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                          "DESIGN"
                        ]
                      }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": (v55/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "consistentRead",
                        "variableName": "consistentRead"
                      }
                    ],
                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignConnection",
                    "kind": "LinkedField",
                    "name": "designs",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v14/*: any*/),
                                  (v48/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "liveEmbedUrl"
                                  },
                                  {
                                    "args": (v51/*: any*/),
                                    "kind": "LinkedField",
                                    "name": "provider",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v14/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "DevOpsSupportedActions",
                                            "kind": "LinkedField",
                                            "name": "supportedActions",
                                            "plural": false,
                                            "selections": [
                                              (v54/*: any*/),
                                              (v53/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "DevOpsDesignProvider"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdated"
                                  },
                                  (v35/*: any*/),
                                  (v31/*: any*/),
                                  (v38/*: any*/)
                                ],
                                "type": "DevOpsDesign"
                              },
                              (v22/*: any*/),
                              (v38/*: any*/)
                            ]
                          },
                          (v14/*: any*/),
                          (v16/*: any*/)
                        ]
                      },
                      (v38/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "workItemModernizationEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": (v52/*: any*/)
      }
    ]
  },
  "params": {
    "id": "1598b086c3f195764dc7f43a077d4dccc64e138fb6bc029f238644fb89a6d38c",
    "metadata": {},
    "name": "ConnectedToIssueAggQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx": isJsmIncidentCommandCenterIncidentSummaryEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterSuggestedResourcesRelayProvidertsx": isJsmIncidentCommandCenterSuggestedResourcesEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsEnabledRelayProvider": JiraAiAgentTeamSessionsEnabledRelayProvider_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiLocalAgentSessionsEnabledRelayProvider": JiraAiLocalAgentSessionsEnabledRelayProvider_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiReadAgentSessionsMainTopLevelAgentRelayProvider": JiraAiReadAgentSessionsMainTopLevelAgent_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAiAgentTeamSessionsTimestampRelayProvider": JiraAiAgentTeamSessionsTimestampRelayProvider_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgentSessionCardExperimentRelayProvider": JiraAgentSessionCardExperimentRelayProvider_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx": removeDesignProviderTypeFilter_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": removeCtiaqConfigState_provider
    }
  }
};
})();

(node as any).hash = "c1856646e12693d96d084159d3596f75";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
